document.addEventListener('DOMContentLoaded', () => {
    const addShowMoreButtonListeners = () => {
        const sections = document.querySelectorAll(".section-reviews-three");
        if (sections) {
            sections.forEach((section, index) => {
                const button = section.querySelector('.reviews-three-show-more');
                if (button) {
                    button.setAttribute('data-index', index + 1);
                }
            })
        }

        sections.forEach((section) => {
            const button = section.querySelector(".reviews-three-show-more");
            if (button) {
                button.addEventListener('click', async (event) => {
                    const button = event.target;
                    button.classList.add('btn-loading');

                    const number = parseInt(button.getAttribute('data-number'));
                    const offset = parseInt(button.getAttribute('data-offset'));
                    const service_id = parseInt(button.getAttribute('data-service-id'));
                    const index = button.getAttribute('data-index');
                    const total = button.getAttribute('data-total');

                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Cache-Control': 'no-cache',
                        },
                        mode: 'no-cors',
                    };

                    const form = new FormData();
                    form.append('action', 'load_more_reviews_three');
                    form.append('number', number);
                    form.append('offset', offset);
                    form.append('service-id', service_id);
                    form.append('index', index);

                    const params = new URLSearchParams(form);
                    options.body = params;

                    try {
                        let response = await fetch('/wp-admin/admin-ajax.php', options);
                        let html = await response.text();
                        if (html) {
                            const reviewsList = section.querySelector('.reviews-three-content-list');
                            const lang = offset + number;

                            reviewsList.insertAdjacentHTML('beforeend', html);

                            if (lang >= total) {
                                button.remove();
                            } else {
                                button.setAttribute('data-offset', lang);
                                button.classList.remove('btn-loading');
                            }
                        }
                    } catch (error) {
                        console.error('Ошибка при загрузке отзывов:', error);
                    }
                });
            }
        });
    };

    addShowMoreButtonListeners();
});
